// Un rôle de la palette (index.css, RDEC-024) là où une classe Tailwind ne
// s'applique pas : style en ligne, attribut SVG d'une bibliothèque de graphes.
export const paletteColor = (role, alpha) =>
  alpha === undefined ? `rgb(var(--color-${role}))` : `rgb(var(--color-${role}) / ${alpha})`;
